/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindCreditRequestsResponseDto } from '../../models/find-credit-requests-response-dto';

export interface FindCreditRequests$Params {
  user_id?: number;
  pending_only: boolean;
  request_state?: string;
  internal_state?: string;
  '$sortby': string;
  '$sortdir': string;
  '$page': number;
  '$maxpagesize': number;
  'X-API-Version'?: string;
}

export function findCreditRequests(http: HttpClient, rootUrl: string, params: FindCreditRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<FindCreditRequestsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, findCreditRequests.PATH, 'get');
  if (params) {
    rb.query('user_id', params.user_id, {});
    rb.query('pending_only', params.pending_only, {});
    rb.query('request_state', params.request_state, {});
    rb.query('internal_state', params.internal_state, {});
    rb.query('$sortby', params['$sortby'], {});
    rb.query('$sortdir', params['$sortdir'], {});
    rb.query('$page', params['$page'], {});
    rb.query('$maxpagesize', params['$maxpagesize'], {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindCreditRequestsResponseDto>;
    })
  );
}

findCreditRequests.PATH = '/api/credit-requests';
